import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Category } from '../state/types'

export const useCategoryLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllCategories = (active = false) => getList(TableName.CATEGORIES, active) as Category[]

        const loadAllCategories = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CATEGORIES, options)
            return response.dataTypes as Category[]
        }

        const loadCategory = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.CATEGORIES, id, dbRequest) as Promise<O<Category>>
        }

        return {
            findAllCategories,
            loadAllCategories,
            loadCategory
        }
    }
}
